module.exports = __webpack_public_path__ + "static/credibility-c0b75dd74a86e12038fee7576ea97c16.jpg";